export const borderRadius = {
    radiusCircle: '100px',
    radiusSmall: '4px',
    radiusMedium: '8px',
    radiusLarge: '24px',
};
